import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/tips／exclamation-circle-fill@2x.png'


const _hoisted_1 = { style: {"background-color":"#f5f5f5","margin-top":"0.7rem"} }
const _hoisted_2 = { class: "requirement_management comBox" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { style: {"display":"flex"} }
const _hoisted_6 = { class: "table_information" }
const _hoisted_7 = { style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis","color":"#333333","font-size":"0.16rem","font-weight":"bold"} }
const _hoisted_8 = { style: {"display":"flex","justify-content":"flex-start","margin-top":"0.04rem"} }
const _hoisted_9 = { style: {"display":"flex","width":"1rem","margin-right":"0.4rem"} }
const _hoisted_10 = { style: {"width":"1.5rem","display":"flex","margin-right":"0.2rem"} }
const _hoisted_11 = { style: {"width":"1rem","display":"flex","margin-right":"0.2rem"} }
const _hoisted_12 = {
  key: 0,
  style: {"width":"0.8rem","display":"flex","margin-right":"0.2rem"}
}
const _hoisted_13 = { style: {"width":"1.3rem","display":"flex","margin-right":"0.2rem"} }
const _hoisted_14 = { style: {"color":"#c01a26"} }
const _hoisted_15 = {
  key: 0,
  style: {"display":"flex"}
}
const _hoisted_16 = { style: {"display":"flex","justify-content":"center","width":"100%"} }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 1,
  style: {"display":"flex","justify-content":"center","width":"100%"}
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  style: {"font-size":"0.12rem","color":"#86909c"}
}
const _hoisted_24 = {
  key: 1,
  style: {"font-size":"0.14rem","color":"#000000","text-align":"center","width":"100%"}
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  key: 2,
  style: {"display":"flex","justify-content":"center","width":"100%"}
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 3,
  style: {"display":"flex","justify-content":"center","width":"100%"}
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 4,
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 5,
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_35 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_36 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_37 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_38 = {
  class: "rate",
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_39 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_40 = { style: {"text-align":"center","font-size":"0.16rem","margin":"0.16rem 0"} }
const _hoisted_41 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_42 = {
  class: "rate",
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_43 = { style: {"display":"flex","justify-content":"center"} }

import leftTemplate3 from "@/components/leftTemplate3.vue";
import { ref, onBeforeUnmount, watch, nextTick } from "vue";
import { ElMessage, TabsPaneContext } from "element-plus";
import { ElTable } from "element-plus";
import { useRouter } from "vue-router";
import { Axios } from "@/assets/js/ls_com_axios.js";
import com_date from "@/assets/js/common.js";
import { serverBaseUrl } from "../../assets/js/ls_tgServerUrls.js";
import Tooltip from "@/components/Tooltip/index.vue";
interface User {
  date: string;
  name: string;
  price: string;
  address: string;
  katype: string;

  number: number;
  time: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'requirement_management',
  setup(__props) {

const upload_action = ref(serverBaseUrl + "/file/upload");
document.title = "标识山西-参与的需求";
const dialogTableVisible = ref(false);
const activeName = ref("first1");
const router = useRouter();
const form = ref({
  condition: {
    state: 0,
  },
  pageIndex: 1,
  pageSize: 12,
  total: 0,
});
const list = ref([]);
const dialogVisible = ref(false);

const dialogEvaluateVisible1 = ref(false);
const EvaluationContentObj = ref({});
const EvaluationContentList = ref([]);
// const Details = (index, row) => {
//   router.push({
//     path: "/ShadowComposerHomepage",
//     query: { id: row.createUserId },
//   });
// };
const handleExceed = () => {
  ElMessage.error("最多上传3个文件");
};
const beforeUpload = (file) => {
  const allowedExtensions = ["zip", "rar"];

  const isAllowedFileType = allowedExtensions.some((extension) =>
    new RegExp(`\\.${extension}$`, "i").test(file.name)
  );

  if (!isAllowedFileType) {
    ElMessage.error("只能上传 zip、rar 格式的文件");
  }

  return isAllowedFileType;
};
const EvaluationContent = (index, row) => {
  dialogVisible.value = true;
  EvaluationContentObj.value.id = row.id;
  Axios(
    "post",
    "/material//material/need/listEvaluate",
    {
      pageIndex: 1,
      pageSize: 20,

      condition: {
        needId: EvaluationContentObj.value.id,
      },
    },
    false,
    function (res) {
      if (res.data.code == 200) {
        console.log(
          "res.data.data.records.records,records",
          res.data.data.records[0]
        );
        if (res.data.data.records && res.data.data.records.length > 0) {
          res.data.data.records.forEach((e) => {
            if (
              e.evaluate_user_id ==
              JSON.parse(localStorage.getItem("userList")).memberId
            ) {
              e.BothParties = "乙方";
            } else {
              e.BothParties = "甲方";
            }
          });
        }
        EvaluationContentList.value = res.data.data.records;

        // EvaluationContentObj.value = res.data.data.records[0];
      } else {
        console.log(res);
      }
    }
  );
};
const evaluate1 = () => { };
// 左侧点击
// condition中包state字段(待签单state = 1 / 已报名state = 0 /待确认 state = 2 / 已拒绝state = 3 / 进行中 state= 4 /待评价 state = 5 / 已评价 state = 6)
const getList = () => {
  let obj = { ...form.value };
  for (let key in obj) {
    if (obj[key] === "" || obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    }
  }
  let obj1 = { ...obj.condition };
  for (let key in obj1) {
    if (obj1[key] === "" || obj1[key] === null || obj1[key] === undefined) {
      delete obj1[key];
    }
  }
  obj.condition = obj1;
  Axios(
    "post",
    "/material/material/need/selectNeed",
    obj,
    false,
    function (res) {
      if (res.data.code == 200) {
        list.value = res.data.data.records;
        if ((form.value.condition.state = 3)) {
          let list1 = [];
          res.data.data.records.forEach((e, index) => {
            e.index = index;
            e.time = "";
            e.countdown = "";
          });
          list1 = res.data.data.records.filter((e, index) => {
            return e.expireFlag === 0 && e.payFlag === 1;
          });

          list1.forEach(async (e) => {
            const expireTime = await getPromiseGetExpireTime(e.id);
            list.value[e.index].time = expireTime;
            startItemCountdown(list.value[e.index], expireTime);
          });
        }
      } else {
        console.log(res);
      }
    }
  );
};
const startItemCountdown = (item: any, expireTime: number) => {
  const endTime = new Date().getTime() + expireTime * 1000;

  const updateCountdown = () => {
    const currentTime = new Date().getTime();
    const timeLeft = endTime - currentTime;

    if (timeLeft <= 0) {
      clearInterval(item.timer);
      console.log(`项目 ${item.id} 的倒计时结束`);
    } else {
      const hours = Math.floor(timeLeft / (1000 * 60 * 60));
      const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
      item.countdown = `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    }
  };

  updateCountdown();
  item.timer = setInterval(updateCountdown, 1000);

  onBeforeUnmount(() => {
    clearInterval(item.timer);
  });
};

// let valueName = "";
// router.currentRoute.value.query
//   ? (valueName = router.currentRoute.value.query.state)
//   : (valueName = "first1");
// valueName ? ((activeName.value = valueName), handleClick) : "";
const handleRemove = (file, fileList1, type) => {
  fileList.value.splice(
    fileList.value.findIndex((item) => item.url === file.url),
    1
  );
};
watch(
  () => router.currentRoute.value.query,
  async (params) => {
    await nextTick();
    console.log("params", params);
    activeName.value = router.currentRoute.value.query.state
      ? router.currentRoute.value.query.state
      : "first1";
    handleClick({ props: { name: activeName.value } });
  },
  { immediate: true }
);
getList();
const handleClose1 = () => {
  dialogEvaluateVisible.value = false;
  evaluateObj.value = {};
};
// 获取24小时倒计时
const getPromiseGetExpireTime = async (id) => {
  let obj = {
    id,
  };
  return new Promise(async (resolve) => {
    await Axios(
      "get",
      "/material/material/need/getExpireTime",
      obj,
      false,
      (res) => {
        resolve(res.data.data);
        // console.log("res.data.data", res.data.data);
      }
    );
  });
};
const activeList = ref([
  {
    label: "已报名",
    name: "first1",
    satus: 0,
  },
  {
    label: "待签单",
    name: "first",
    satus: 1,
  },
  {
    label: "待确认",
    name: "second",
    satus: 2,
  },
  {
    label: "进行中",
    name: "third",
    satus: 4,
  },
  {
    label: "待评价",
    name: "four",
    satus: 5,
  },
  {
    label: "已终止",
    name: "five",
    satus: 3,
  },
  {
    label: "已评价",
    name: "six1",
    satus: 6,
  },
]);
const handleClick = (tab: TabsPaneContext, event: Event) => {
  console.log(tab.props.name);
  //   condition中包state字段(待签单state = 1 / 已报名state = 0 /待确认 state = 2 / 已拒绝state = 3 / 进行中 state= 4 /待评价 state = 5 / 已评价 state = 6)
  activeList.value.forEach((e) => {
    if (e.name == tab.props.name) {
      form.value.condition.state = e.satus;
    }
  });
  list.value = [];
  getList();
};

// 表格

const multipleTableRef = ref<InstanceType<typeof ElTable>>();
const multipleSelection = ref<User[]>([]);
const toggleSelection = (rows?: User[]) => {
  if (rows) {
    rows.forEach((row) => {
      multipleTableRef.value!.toggleRowSelection(row, undefined);
    });
  } else {
    multipleTableRef.value!.clearSelection();
  }
};
const handleSelectionChange = (val: User[]) => {
  multipleSelection.value = val;
};
var data = []; // 创建一个空数组

for (var i = 0; i < 10; i++) {
  data.push({
    id: "45648941615641",
    name: "5月24日广州南沙活动拍摄",

    price: "￥5000.00",
    time: "2023-06-08 15:14",
    katype: 1,
    faid: "/",
    number: 34,
  }); // 将相同的数据添加到数组中
}
const tableData: User[] = data;
const obj = ref({});
// 签约
let dialogSignVisible = ref(false);
const handleSign = (index, row) => {
  dialogSignVisible.value = true;
  /*
   bankBranch:'支行名称
bankName:开户行
bankNo	银行卡号/微信号/支付宝账号
bankType 银行卡类型（DEBITCARD=储蓄卡，CREDITCARD=信用卡，ALIPAY=支付宝，WECHAT=微信）
idCard	身份证号
mobile 手机号
realName 真实姓名

  */
  // Axios(
  //   "post",
  //   "/member/member-bank",
  //   {
  //     bankBranch: "工商银行",
  //     bankName: "工商银行",
  //     bankNo: "1",
  //     bankType: "DEBITCARD",
  //     mobile: "1",
  //     idCard: "1",
  //     realName: "姓名",
  //   },
  //   false,
  //   function (res) {
  //     if (res.data.code == 200) {
  //       // list.value = res.data.data.records;
  //       getList();
  //     } else {
  //       console.log(res);
  //     }
  //   }
  // );
  Axios("GET", "/member/member-bank/my-list", null, false, function (res) {
    if (res.data.data.length) {
      bankCardList.value = res.data.data;
    } else {
      console.log(2121);
      ElMessage.warning("暂无银行卡");
      router.push({
        path: "/bankCard",
        query: {
          showDialog: true,
        },
      });
    }
  });
  obj.value = row;
};
const bankCardList = ref([]);
const submitForm = () => {
  if (!form.value.region) {
    ElMessage.warning("请选择银行卡");
    return;
  }
  let obj1 = {
    bankCode: form.value.region,
    needId: obj.value.id,
    // needUser: {
    //   bankCode: form.value.region,
    //   needId: obj.value.id,
    //   state: 2,
    // },
    state: 2,
  };

  Axios(
    "post",
    "/material/material/need/signBillOrRefuse",
    obj1,
    false,
    function (res) {
      if (res.data.code === 200) {
        // list.value = res.data.data.records;
        ElMessage.success("签单成功");
        dialogSignVisible.value = false;
        form.value.region = "";
        form.value.condition.state = 1;
        getList();
      } else {
        console.log(res);
      }
    }
  );
};

// 拒绝
let title = ref("");
let dialogDownVisible = ref(false);
let ids = ref([]);
const handleDown = (index, row, type) => {
  ids.value = [];
  title.value =
    type == "del" ? "是否确认删除此需求订单？" : "是否确认拒绝此订单？";
  dialogDownVisible.value = true;
  ids.value.push(row.id);
};
const del = () => {
  let obj1 = {
    // bankCode: "1",
    needId: ids.value[0],
    // needUser: {
    // bankCode: "1",
    // needId: ids.value[0],
    // state: 3,
    // },
    state: 3,
  };

  title.value == "是否确认拒绝此订单？"
    ? Axios(
      "post",
      "/material/material/need/signBillOrRefuse",
      obj1,
      false,
      function (res) {
        if (res.data.code == 200) {
          // list.value = res.data.data.records;
          ElMessage.success("拒绝成功");
          form.value.condition.state = 1;
          getList();
          dialogDownVisible.value = false;
        } else {
          console.log(res);
        }
      }
    )
    : Axios(
      "post",
      "/material/material/need/delB",
      ids.value,
      false,
      function (res) {
        if (res.data.code == 200) {
          // list.value = res.data.data.records;
          ElMessage.success("删除成功");
          form.value.condition.state = 6;
          getList();
          dialogDownVisible.value = false;
        } else {
          console.log(res);
        }
      }
    );
};
//确认合作
const submitForm1 = () => {
  let obj1 = {
    ...obj.value,
  };
  Axios("post", "/material/material/need/confirm", obj1, false, function (res) {
    if (res.data.code == 200) {
      // list.value = res.data.data.records;
      cooperationVisible.value = false;
      ElMessage.success("确认合作成功");
      form.value.condition.state = 2;
      getList();
    } else {
      console.log(res);
    }
  });
};
let cooperationVisible = ref(false);

const handleCooperation = (index, row, type) => {
  cooperationVisible.value = true;
  obj.value = row;
};

//无法胜任
let dialogIncompetencyVisible = ref(false);
const handleIncompetency = (index, row, type) => {
  dialogIncompetencyVisible.value = true;
};
//评价
let dialogEvaluateVisible = ref(false);
const handleEvaluate = (index, row, type) => {
  evaluateObj.value.needId = row.id;
  dialogEvaluateVisible.value = true;
};
let evaluateObj = ref({});
const evaluate = () => {
  evaluateObj.value.type = 0;
  if (!evaluateObj.value.evaluateStar || !evaluateObj.value.evaluateContent) {
    return ElMessage.warning("内容不能为空，请选择评级和输入内容");
  }
  Axios(
    "post",
    "/material//material/need/evaluate",
    evaluateObj.value,
    false,
    function (res) {
      if (res.data.code == 200) {
        dialogEvaluateVisible.value = false;
        evaluateObj.value = {};
        ElMessage.success("评价成功");
        getList();
      } else {
        console.log(res);
      }
    }
  );
};

//完成交付
let dialogCompleteVisible = ref(false);
let obj2 = ref({});
// dialogCompleteVisible.value = true;
const handleComplete = (index, row, type) => {
  fileList.value = [];
  dialogCompleteVisible.value = true;
  obj2.value = row;
};
let fileList = ref([]);
const onSuccess = (res, file) => {
  fileList.value.push({ name: res.data.name, url: res.data.url });
};
const Delivery = () => {
  let obj1 = { ...obj2.value };
  if (!fileList.value.length) {
    return ElMessage.warning("请上传文件");
  }
  obj1.deliveryFile = fileList.value.map((item) => item.url).join(",");
  // return console.log(fileList.value);
  Axios("post", "/material/material/need/finish", obj1, false, function (res) {
    if (res.data.code == 200) {
      dialogCompleteVisible.value = false;
      ElMessage.success("完成交付");
      form.value.condition.state = 4;
      getList();
    } else {
      console.log(res);
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_rate = _resolveComponent("el-rate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(leftTemplate3, { left_tabShow: 'requirement_management' })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[29] || (_cache[29] = _createElementVNode("div", { style: {"height":"0.08rem"} }, null, -1)),
        _createVNode(_component_el_tabs, {
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
          class: "demo-tabs",
          onTabClick: handleClick
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeList.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_tab_pane, {
                label: item.label,
                name: item.name,
                key: item
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElTable), {
                    ref_for: true,
                    ref_key: "multipleTableRef",
                    ref: multipleTableRef,
                    data: list.value,
                    style: {"width":"100%"},
                    height: "650"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        property: "name",
                        label: "需求内容"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("div", _hoisted_7, _toDisplayString(row.projectName), 1),
                              _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("span", _hoisted_9, [
                                  _cache[23] || (_cache[23] = _createElementVNode("div", { class: "table_title" }, "工作地点：", -1)),
                                  _createVNode(Tooltip, {
                                    class: "table_name",
                                    text: row.workPlace ? row.workPlace : '暂无'
                                  }, null, 8, ["text"])
                                ]),
                                _createElementVNode("span", _hoisted_10, [
                                  _cache[24] || (_cache[24] = _createElementVNode("div", { class: "table_title" }, "交付时间：", -1)),
                                  _createVNode(Tooltip, {
                                    class: "table_name",
                                    text: _unref(com_date).com_date.timestamp_string(
                            row.deliveryTime,
                            false,
                            `-`,
                            `:`
                          )
                            
                                  }, null, 8, ["text"])
                                ]),
                                _createElementVNode("span", _hoisted_11, [
                                  _cache[25] || (_cache[25] = _createElementVNode("div", { class: "table_title" }, "发布人：", -1)),
                                  _createVNode(Tooltip, {
                                    class: "table_name",
                                    text: row.nickName,
                                    id: row.createUserId
                                  }, null, 8, ["text", "id"])
                                ]),
                                (activeName.value == 'first1')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "table_title" }, "已报名：", -1)),
                                      _createVNode(Tooltip, {
                                        class: "table_name",
                                        text: row.signUpNum ? row.signUpNum : 0
                                      }, null, 8, ["text"])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", _hoisted_13, [
                                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "table_title" }, "技能类型：", -1)),
                                  _createVNode(Tooltip, {
                                    class: "table_name",
                                    text: row.skillType ? row.skillType : '暂无'
                                  }, null, 8, ["text"])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "需求预算",
                        width: "100",
                        align: "center"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createElementVNode("div", _hoisted_14, _toDisplayString(row.price ? "￥" : "") + _toDisplayString((row.price / 1).toFixed(2)), 1)
                        ]),
                        _: 1
                      }),
                      (activeName.value == 'six')
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 0,
                            label: "合作人",
                            width: "120",
                            align: "center"
                          }, {
                            default: _withCtx(() => _cache[28] || (_cache[28] = [
                              _createElementVNode("div", { style: {"color":"#333333"} }, "未选择", -1)
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (activeName.value != 'first1')
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 1,
                            label: "操作",
                            width: 200,
                            align: "center"
                          }, {
                            default: _withCtx((scope) => [
                              (activeName.value == 'first')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                      _createElementVNode("div", {
                                        onClick: ($event: any) => (handleSign(scope.$index, scope.row)),
                                        class: "topBtn"
                                      }, " 签单 ", 8, _hoisted_17),
                                      _createElementVNode("div", {
                                        style: {"margin-left":"0.1rem","line-height":"0.43rem","color":"#ff2929"},
                                        onClick: ($event: any) => (handleDown(scope.$index, scope.row, 'down'))
                                      }, " 拒绝 ", 8, _hoisted_18)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (activeName.value == 'second')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    (scope.row.expireFlag == 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                          (scope.row.payFlag == 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                _createElementVNode("div", {
                                                  onClick: ($event: any) => (handleCooperation(scope.$index, scope.row)),
                                                  class: "topBtn"
                                                }, " 确认合作 ", 8, _hoisted_22),
                                                (scope.row.hasOwnProperty('time'))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(scope.row.countdown) + "小时未确认合作，订单将取消 ", 1))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_24, " 等待对方付款... "))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (scope.row.expireFlag == 1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, " 未确认合作,订单已过期 "))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (activeName.value == 'third')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _createElementVNode("div", {
                                      onClick: ($event: any) => (handleComplete(scope.$index, scope.row)),
                                      class: "topBtn"
                                    }, _toDisplayString(JSON.stringify(scope.row.deliveryFile) ===
                        JSON.stringify(null) ? '上传交付文件' : '重新上传'), 9, _hoisted_27)
                                  ]))
                                : _createCommentVNode("", true),
                              (activeName.value == 'four')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                    _createElementVNode("div", {
                                      onClick: ($event: any) => (handleEvaluate(scope.$index, scope.row)),
                                      class: "topBtn"
                                    }, " 合作评价 ", 8, _hoisted_29)
                                  ]))
                                : _createCommentVNode("", true),
                              (activeName.value == 'five')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    _createElementVNode("div", {
                                      style: {"margin-left":"0.1rem","line-height":"0.43rem","color":"#c01a26"},
                                      onClick: ($event: any) => (handleDown(scope.$index, scope.row, 'del'))
                                    }, " 删除 ", 8, _hoisted_31)
                                  ]))
                                : _createCommentVNode("", true),
                              (activeName.value == 'six1')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                    _createElementVNode("div", {
                                      onClick: ($event: any) => (EvaluationContent(scope.$index, scope.row)),
                                      class: "topBtn1"
                                    }, " 评价列表 ", 8, _hoisted_33)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["data"])
                ]),
                _: 2
              }, 1032, ["label", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    (dialogVisible.value)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          title: "评价列表",
          modelValue: dialogVisible.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
          width: "480px",
          "close-on-click-modal": false
        }, {
          default: _withCtx(() => [
            (EvaluationContentList.value.length)
              ? (_openBlock(), _createBlock(_unref(ElTable), {
                  key: 0,
                  data: EvaluationContentList.value,
                  style: {"width":"100%"},
                  "header-cell-style": { 'text-align': 'center' },
                  "cell-style": { 'text-align': 'center' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "序号",
                      type: "index",
                      width: "60"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "评价星级",
                      prop: "evaluate_star"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "评价内容",
                      prop: "evaluate_content"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "评价方",
                      prop: "BothParties"
                    })
                  ]),
                  _: 1
                }, 8, ["data"]))
              : _createCommentVNode("", true),
            _cache[30] || (_cache[30] = _createElementVNode("div", { style: {"height":"50px"} }, null, -1))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      title: "签单",
      modelValue: _unref(dialogSignVisible),
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(dialogSignVisible) ? (dialogSignVisible).value = $event : dialogSignVisible = $event)),
      "align-center": "",
      width: "480px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _cache[31] || (_cache[31] = _createElementVNode("div", { style: {"width":"0.4rem","height":"0.4rem","margin":"0 auto"} }, [
          _createElementVNode("img", {
            style: {"height":"100%"},
            src: _imports_0
          })
        ], -1)),
        _cache[32] || (_cache[32] = _createElementVNode("div", { style: {"text-align":"center","font-size":"0.16rem","margin":"0.16rem 0"} }, " 是否确认签单？ ", -1)),
        _cache[33] || (_cache[33] = _createElementVNode("div", { style: {"color":"#86909c","text-align":"center","font-size":"0.14rem","margin-bottom":"0.2rem"} }, " 甲方已将需求金额托管到平台，需求订单完成后，将发放到您所属银行卡账户 ", -1)),
        _createVNode(_component_el_form, {
          model: form.value,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "到账银行卡" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  style: {"width":"100%"},
                  modelValue: form.value.region,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.region) = $event)),
                  placeholder: "请选择银行"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bankCardList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.bankName,
                        value: item.bankNo
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", {
            class: "dataBtnClose",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_isRef(dialogSignVisible) //@ts-ignore
 ? dialogSignVisible.value = false : dialogSignVisible = false))
          }, "取消"),
          _createElementVNode("div", {
            class: "dataBtnSubmit",
            onClick: submitForm
          }, "确认")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "无法胜任",
      modelValue: _unref(dialogIncompetencyVisible),
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(dialogIncompetencyVisible) ? (dialogIncompetencyVisible).value = $event : dialogIncompetencyVisible = $event)),
      "align-center": "",
      width: "480px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _cache[35] || (_cache[35] = _createElementVNode("div", { style: {"color":"#000000","margin-bottom":"0.16rem","font-size":"0.14rem","font-weight":"bold"} }, " 请填写无法胜任的原因 ", -1)),
        _createVNode(_component_el_input, {
          modelValue: form.value.textarea,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.textarea) = $event)),
          maxlength: "1000",
          placeholder: "请输入原因",
          "show-word-limit": "",
          type: "textarea"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", {
            class: "dataBtnClose",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_isRef(dialogIncompetencyVisible) //@ts-ignore
 ? dialogIncompetencyVisible.value = false : dialogIncompetencyVisible = false))
          }, " 取消 "),
          _cache[34] || (_cache[34] = _createElementVNode("div", { class: "dataBtnSubmit" }, "确认", -1))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "",
      modelValue: _unref(cooperationVisible),
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(cooperationVisible) ? (cooperationVisible).value = $event : cooperationVisible = $event)),
      "align-center": "",
      width: "480px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _cache[36] || (_cache[36] = _createElementVNode("div", { style: {"width":"0.4rem","height":"0.4rem","margin":"0 auto"} }, [
          _createElementVNode("img", {
            style: {"height":"100%"},
            src: _imports_0
          })
        ], -1)),
        _cache[37] || (_cache[37] = _createElementVNode("div", { style: {"text-align":"center","font-size":"0.16rem","margin":"0.16rem 0"} }, " 是否确认与此甲方进行合作？ ", -1)),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", {
            class: "dataBtnClose",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_isRef(cooperationVisible) //@ts-ignore
 ? cooperationVisible.value = false : cooperationVisible = false))
          }, "取消"),
          _createElementVNode("div", {
            class: "dataBtnSubmit",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (submitForm1()))
          }, "确认")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "完成交付",
      modelValue: _unref(dialogCompleteVisible),
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(dialogCompleteVisible) ? (dialogCompleteVisible).value = $event : dialogCompleteVisible = $event)),
      "align-center": "",
      width: "480px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _cache[39] || (_cache[39] = _createElementVNode("div", { style: {"color":"#000000","margin-bottom":"0.16rem","font-size":"0.14rem"} }, " 上传交付文件 ", -1)),
        _createVNode(_component_el_upload, {
          class: "upload-demo",
          action: upload_action.value,
          "before-upload": beforeUpload,
          "on-preview": _ctx.handlePreview,
          "on-remove": handleRemove,
          "on-success": onSuccess,
          limit: 3,
          "on-exceed": handleExceed,
          "file-list": _unref(fileList)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              plain: ""
            }, {
              default: _withCtx(() => _cache[38] || (_cache[38] = [
                _createTextVNode("点击上传")
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["action", "on-preview", "file-list"]),
        _cache[40] || (_cache[40] = _createElementVNode("div", { style: {"background":"#ffede3","padding":"0.1rem","color":"#ff8741","border-radius":"8px"} }, " 请将文件压缩为zip、rar压缩格式后上传 ", -1)),
        _cache[41] || (_cache[41] = _createElementVNode("div", { style: {"margin":"0.2rem 0","color":"#86909c"} }, " 甲方验收无误后，需求金额将在2个工作日内发放到您的银行卡账户 ", -1)),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", {
            class: "dataBtnClose",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_isRef(dialogCompleteVisible) //@ts-ignore
 ? dialogCompleteVisible.value = false : dialogCompleteVisible = false))
          }, " 取消 "),
          _createElementVNode("div", {
            class: "dataBtnSubmit",
            onClick: Delivery
          }, "确认")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "合作评价",
      modelValue: _unref(dialogEvaluateVisible),
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(dialogEvaluateVisible) ? (dialogEvaluateVisible).value = $event : dialogEvaluateVisible = $event)),
      "align-center": "",
      "before-close": handleClose1,
      width: "480px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _cache[42] || (_cache[42] = _createElementVNode("div", { style: {"color":"#86909c","font-size":"0.14rem","text-align":"center","margin-bottom":"0.18rem"} }, " 评价星级 ", -1)),
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_el_rate, {
            modelValue: _unref(evaluateObj).evaluateStar,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(evaluateObj).evaluateStar) = $event)),
            size: "large"
          }, null, 8, ["modelValue"])
        ]),
        _cache[43] || (_cache[43] = _createElementVNode("div", { style: {"color":"#000000","margin-bottom":"0.16rem","font-size":"0.14rem"} }, " 评价内容 ", -1)),
        _createVNode(_component_el_input, {
          modelValue: _unref(evaluateObj).evaluateContent,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(evaluateObj).evaluateContent) = $event)),
          maxlength: "30",
          placeholder: "输入评价内容",
          "show-word-limit": "",
          type: "textarea"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", {
            class: "dataBtnClose",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_isRef(dialogEvaluateVisible) //@ts-ignore
 ? dialogEvaluateVisible.value = false : dialogEvaluateVisible = false))
          }, " 取消 "),
          _createElementVNode("div", {
            class: "dataBtnSubmit",
            onClick: evaluate
          }, "确认")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "",
      modelValue: _unref(dialogDownVisible),
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_isRef(dialogDownVisible) ? (dialogDownVisible).value = $event : dialogDownVisible = $event)),
      "align-center": "",
      width: "480px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _cache[44] || (_cache[44] = _createElementVNode("div", { style: {"width":"0.4rem","height":"0.4rem","margin":"0 auto"} }, [
          _createElementVNode("img", {
            style: {"height":"100%"},
            src: _imports_0
          })
        ], -1)),
        _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(title)), 1),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", {
            class: "dataBtnClose",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_isRef(dialogDownVisible) //@ts-ignore
 ? dialogDownVisible.value = false : dialogDownVisible = false))
          }, "取消"),
          _createElementVNode("div", {
            class: "dataBtnSubmit",
            onClick: del
          }, "确认")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "评价内容",
      modelValue: dialogEvaluateVisible1.value,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((dialogEvaluateVisible1).value = $event)),
      "align-center": "",
      width: "480px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _cache[45] || (_cache[45] = _createElementVNode("div", { style: {"color":"#86909c","font-size":"0.14rem","text-align":"center","margin-bottom":"0.18rem"} }, " 评价星级 ", -1)),
        _createElementVNode("div", _hoisted_42, [
          _createVNode(_component_el_rate, {
            disabled: "",
            modelValue: EvaluationContentObj.value.evaluateStar,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((EvaluationContentObj.value.evaluateStar) = $event)),
            size: "large"
          }, null, 8, ["modelValue"])
        ]),
        _cache[46] || (_cache[46] = _createElementVNode("div", { style: {"color":"#000000","margin-bottom":"0.16rem","font-size":"0.14rem"} }, " 评价内容 ", -1)),
        _createVNode(_component_el_input, {
          modelValue: EvaluationContentObj.value.evaluateContent,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((EvaluationContentObj.value.evaluateContent) = $event)),
          maxlength: "30",
          disabled: "",
          placeholder: "输入评价内容",
          "show-word-limit": "",
          type: "textarea"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", {
            class: "dataBtnClose",
            onClick: _cache[21] || (_cache[21] = ($event: any) => (dialogEvaluateVisible1.value = false))
          }, " 取消 ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})